import { createStore } from "zustand-x";
import { createJSONStorage } from "zustand/middleware";
import hashStorage from "../../utils/storage";
import { UseFormReturnType } from "@mantine/form";
import { isNil, omit, omitBy } from "lodash";

const filterStore = createStore<{ data: any }>(
  {
    data: {},
  },
  {
    name: "filter",
    immer: {
      enabled: true,
    },
    persist: {
      enabled: false,
      storage: createJSONStorage(() => hashStorage),
    },
  }
)
  .extendActions((set, get) => ({
    reset: () => {
      set.data({});
    },
    remove: (
      key: string,
      form: UseFormReturnType<{}, (values: {}) => {}>,
      type?: string
    ) => {
      const _typeof = typeof get.data()?.[key];
      set.data(omit(get.data(), key));
      console.log("<<Type of", _typeof);
      console.log("<< Type", type);
      form.setValues({
        [key]: ["string", "number"].includes(_typeof)
          ? null
          : type === "date"
          ? null
          : [],
      });
    },
  }))
  .extendSelectors((set, get) => ({
    // Below method returns boolean to check that filter is applied or not
    applied: () => {
      return Object.keys(
        omitBy(
          get.data(),
          (value) =>
            isNil(value) || (typeof value === "object" && value?.length === 0)
        )
      ).length > 0
        ? true
        : false;
    },
  }));

export default filterStore;
